module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_24.68543967.jpg";